import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["org", "desktopNav", "mobileToggle", "dropdownCaret", "userCaret"]

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.onResize = this.onResize.bind(this)

    document.addEventListener("click", this.closeOnClickOutside)
    window.addEventListener("resize", this.onResize)

    this.measureAndToggle()
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
    window.removeEventListener("resize", this.onResize)
  }

  // --- Dynamic menu measurement (ported from legacy) ---

  measureAndToggle() {
    if (!this.hasDesktopNavTarget) return

    if (!this.cachedWidths) {
      const parent = this.desktopNavTarget.parentElement
      const rightSide = parent ? parent.lastElementChild : null
      this.cachedWidths = {
        menu: this.measureNav(this.desktopNavTarget),
        org: this.hasOrgTarget ? this.orgTarget.offsetWidth : 0,
        right: rightSide ? rightSide.offsetWidth : 0
      }
    }

    const { menu, org, right } = this.cachedWidths
    const gap = 32 // minimum gap between nav and sides
    const center = window.innerWidth / 2
    const navLeft = center - menu / 2
    const navRight = center + menu / 2
    const leftEnd = org + gap
    const rightStart = window.innerWidth - right - gap
    const showMini = window.innerWidth < 768 || navLeft < leftEnd || navRight > rightStart

    if (this.isMini === showMini) return
    this.isMini = showMini

    this.desktopNavTarget.classList.toggle("hidden", showMini)
    if (this.hasMobileToggleTarget) this.toggle(this.mobileToggleTarget, showMini, "inline-flex")
  }

  measureNav(nav) {
    let width = 0
    nav.querySelectorAll(":scope > *").forEach((item) => {
      width += item.offsetWidth + (item.querySelector("i.fa") ? 20 : 5)
    })
    return width
  }

  toggle(el, show, displayClass) {
    el.classList.toggle("hidden", !show)
    el.classList.toggle(displayClass, show)
  }

  onResize() {
    this.measureAndToggle()
  }

  // --- Dropdowns ---

  toggleDropdown(event) {
    const dropdown = event.currentTarget.closest("[data-dropdown-id]")
    if (!dropdown) return

    const dropdownId = dropdown.dataset.dropdownId
    const menu = this.element.querySelector(`[data-dropdown-menu="${dropdownId}"]`)
    if (!menu) return

    this.closeAllDropdowns(dropdownId)
    const isOpen = menu.classList.toggle("hidden")
    this.toggleCaret(dropdownId, !isOpen)
  }

  // --- Shared ---

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.closeAllDropdowns()
    }
  }

  closeAllDropdowns(exceptId = null) {
    this.element.querySelectorAll("[data-dropdown-menu]").forEach((menu) => {
      if (exceptId && menu.dataset.dropdownMenu === exceptId) return
      menu.classList.add("hidden")
    })
    if (exceptId !== "mobile-menu") this.toggleCaret("mobile-menu", false)
    if (exceptId !== "user-menu") this.toggleCaret("user-menu", false)
  }

  toggleCaret(dropdownId, open) {
    const caretMap = { "mobile-menu": "dropdownCaret", "user-menu": "userCaret" }
    const target = caretMap[dropdownId]
    if (target && this[`has${target.charAt(0).toUpperCase() + target.slice(1)}Target`]) {
      this[`${target}Target`].classList.toggle("rotate-180", open)
    }
  }
}
